import { action, makeAutoObservable } from "mobx"; 
import { PaginationModel } from "@mindmemobile/mm-shared-global";
import { MediaGridResponseModel } from "../models/MediaModel";


export default class MediaStore {
  public medias: MediaGridResponseModel[] = [];
  public pagination: PaginationModel = new PaginationModel({ pageNumber: 1, pageSize: 10 });
  public searchValue = '';
  public mediaOption = 'image';
  constructor() {
      makeAutoObservable(this);
  }

  @action
  updateMedias(data: MediaGridResponseModel[]): void {
      this.medias = data.map((m) => new MediaGridResponseModel(m));
  }

  @action
  updatePagination(pagination: PaginationModel): void {
      this.pagination = new PaginationModel(pagination);
  }

  @action
  updateMediaOption(value: string) {
      this.mediaOption = value;
  }
}
